import React from 'react';
import { SkeletonPanel, SkeletonText, SkeletonPage } from '../../components';



export const PayoutLoader: React.FC = () => {
  return (
    <SkeletonPage
      title={true}
      subtitle={true}
      actions={true}
      breadcrumbs={true}
      loading={true}
    >
      <div className="flex flex-wrap items-start justify-center gap-5">
        <div className="min-w-[51%] flex-[2_2_30rem] space-y-5">
          <SkeletonPanel title={true}>
            <SkeletonPanel.Section>
              <div className="grid grid-cols-4 gap-6">
                <div className='col-span-4 sm:col-span-2'>
                  <SkeletonText lines={1} width={100} />
                </div>
              </div>
            </SkeletonPanel.Section>
          </SkeletonPanel>
        </div>
        <div className="min-w-0 flex-[1_1_15rem] space-y-5">
          <SkeletonPanel>
            <SkeletonPanel.Section title={true}>
              <SkeletonText lines={2} />
            </SkeletonPanel.Section>
            <SkeletonPanel.Section subdued>
              <SkeletonText lines={3} />
            </SkeletonPanel.Section>
            <SkeletonPanel.Section >
              <SkeletonText lines={2} />
            </SkeletonPanel.Section>
          </SkeletonPanel>
        </div>
      </div>
    </SkeletonPage>
  );
};
